import { defineMobileFormWindow } from "@app/overlay";
import {
    StockPartialInventoryFilterForm,
    type StockPartialInventoryFilterFormProps,
} from "./components/StockPartialInventoryFilter/StockPartialInventoryFilterForm";

/** Окна списка АПН для частичной инвентаризации склада. */
export const stockPartialInventoryListWindows = {
    filter: defineMobileFormWindow<StockPartialInventoryFilterFormProps>({
        key: "stock.partialInventory.filter",
        title: "Фильтр АПН для частичной инвентаризации склада",
        component: StockPartialInventoryFilterForm,
    }),
};
